import "./style.scss";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/logo/logo.png";
import { useTranslation } from "react-i18next";
import i18n from "../../locale/i18n";
import Menu from "../../assets/images/icMenu.png";
import Close from "../../assets/images/icClose.png";
import { useState } from "react";
import icUp from "../../assets/images/icUp.png";
import icDown from "../../assets/images/icDown.png";

const AppHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [hasSub, setHasSub] = useState(false);
  const [subIndex, setSubIndex] = useState(-1);
  const [mobileIndex, setMobileIndex] = useState(-1);
  const [menuVisible, setMenuVisible] = useState(false);
  const changeLanguage = (lang) => {
    localStorage.setItem("lang", lang);
    window.location.reload();
  };
  return (
    <div className="app-header">
      <div className="content">
        <div className="logo-wrap">
          <Link to="/">
            <img src={Logo} alt="logo" />
          </Link>
        </div>
        <div
          className="menu-wrap"
          onMouseEnter={() => setHasSub(true)}
          onMouseLeave={() => setHasSub(false)}
        >
          <a
            onMouseEnter={() => setSubIndex(0)}
            onClick={() => {
              navigate("/company");
              setSubIndex(-1);
            }}
          >
            {t(`appHeader.company`)}
          </a>
          <a
            onMouseEnter={() => setSubIndex(1)}
            onClick={() => {
              navigate("/product/ai/graph_rag");
              setSubIndex(-1);
            }}
          >
            {t(`appHeader.product`)}
          </a>
          <a
            onMouseEnter={() => setSubIndex(2)}
            onClick={() => {
              navigate("/service/pgts");
              setSubIndex(-1);
            }}
          >
            {t(`appHeader.service`)}
          </a>
          <a
            onMouseEnter={() => setSubIndex(3)}
            onClick={() => {
              console.log("???");
              navigate("/resource", {
                state: {
                  index: 0,
                },
              });
              setSubIndex(-1);
            }}
          >
            {t(`appHeader.resource`)}
          </a>
          <a
            onMouseEnter={() => setSubIndex(4)}
            onClick={() => {
              navigate("/newsroom");
              setSubIndex(-1);
            }}
          >
            {t(`appHeader.newsRoom`)}
          </a>
          <a
            onMouseEnter={() => setSubIndex(5)}
            onClick={() => {
              navigate("/ir", {
                state: {
                  index: 0,
                },
              });
              setSubIndex(-1);
            }}
          >
            {t(`appHeader.ir`)}
          </a>
          <Link
            target="_blank"
            to="https://jumpit.saramin.co.kr/company/MjIwODg2ODQwOA==?company_nm=%EC%8A%A4%EC%B9%B4%EC%9D%B4%EC%9B%94%EB%93%9C%EC%99%80%EC%9D%B4%EB%93%9C"
            onMouseEnter={() => setSubIndex(-1)}
          >
            {t(`appHeader.careers`)}
          </Link>

          {hasSub && (
            <div className="sub-wrap">
              {subIndex === 0 && (
                <div className="sub-menu">
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/company");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.coreValue`)}
                    </a>
                  </div>
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/company", {
                          state: {
                            index: 1,
                          },
                        });
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.leadership`)}
                    </a>
                  </div>
                  <div className="menu-item"></div>
                </div>
              )}
              {subIndex === 1 && (
                <div className="sub-menu">
                  <div className="menu-item">
                    <a className="strong">AI</a>
                    <a
                      onClick={() => {
                        navigate("/product/ai/graph_rag");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.graphRAG`)}
                    </a>
                    <a
                      onClick={() => {
                        navigate("/product/ai/marketing_solution");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.marketing`)}
                    </a>
                    <a
                      onClick={() => {
                        navigate("/product/ai/video_production");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.production`)}
                    </a>
                  </div>
                  <div className="menu-item">
                    <a className="strong">DBMS</a>
                    <a
                      onClick={() => {
                        navigate("/product/dbms/agens_graph");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.agensGraph`)}
                    </a>
                    <a
                      onClick={() => {
                        navigate("/product/dbms/agens_sql");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.agensSQL`)}
                    </a>
                  </div>
                  <div className="menu-item">
                    <a className="strong">ONTOLOGY</a>
                    <a
                      onClick={() => {
                        navigate("/product/ontology");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.ontology`)}
                    </a>
                  </div>
                </div>
              )}
              {subIndex === 2 && (
                <div className="sub-menu">
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/service/pgts");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.pgts`)}
                    </a>
                  </div>
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/service/education");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.education`)}
                    </a>
                  </div>
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/service/techportal");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.techportal`)}
                    </a>
                  </div>
                </div>
              )}
              {subIndex === 3 && (
                <div className="sub-menu">
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/resource", {
                          state: {
                            index: 0,
                          },
                        });
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.manual`)}
                    </a>
                  </div>
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/resource", {
                          state: {
                            index: 1,
                          },
                        });
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.whitepaper`)}
                    </a>
                  </div>
                  <div className="menu-item"></div>
                </div>
              )}
              {subIndex === 4 && (
                <div className="sub-menu">
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/newsroom");
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.pressRelease`)}
                    </a>
                  </div>
                  <div className="menu-item"></div>
                  <div className="menu-item"></div>
                </div>
              )}
              {subIndex === 5 && (
                <div className="sub-menu">
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/ir", {
                          state: {
                            index: 0,
                          },
                        });
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.report`)}
                    </a>
                  </div>
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/ir", {
                          state: {
                            index: 1,
                          },
                        });
                        setSubIndex(-1);
                      }}
                    >
                      {t(`appHeader.announcement`)}
                    </a>
                  </div>
                  <div className="menu-item">
                    <a
                      className="strong"
                      onClick={() => {
                        navigate("/ir", {
                          state: {
                            index: 2,
                          },
                        });
                        setSubIndex(-1);
                      }}
                    >
                      CI
                    </a>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
        <div className="lang-wrap">
          <button
            className={i18n.language === "ko" ? "active" : ""}
            onClick={() => changeLanguage("ko")}
          >
            KOR
          </button>
          <div className="block" />
          <button
            className={i18n.language === "en" ? "active" : ""}
            onClick={() => changeLanguage("en")}
          >
            ENG
          </button>
        </div>
        <div className="mobile-wrap">
          <button onClick={() => setMenuVisible(true)}>
            <img src={Menu} alt="" />
          </button>
        </div>
        {menuVisible && (
          <div className="mobile-menu-wrap">
            <div className="header-wrap">
              <div className="logo-wrap">
                <Link
                  onClick={() => {
                    navigate("/");
                    setMenuVisible(false);
                  }}
                >
                  <img src={Logo} alt="logo" />
                </Link>
              </div>
              <div className="lang-wrap">
                <button
                  className={i18n.language === "ko" ? "active" : ""}
                  onClick={() => changeLanguage("ko")}
                >
                  KOR
                </button>
                <div className="block" />
                <button
                  className={i18n.language === "en" ? "active" : ""}
                  onClick={() => changeLanguage("en")}
                >
                  ENG
                </button>
              </div>
              <div className="mobile-wrap">
                <button onClick={() => setMenuVisible(false)}>
                  <img src={Close} alt="" />
                </button>
              </div>
            </div>
            <div className="item-wrap">
              <div
                className="item"
                onClick={() => {
                  navigate("/company");
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.company`)}</p>
              </div>
              <div
                className="item"
                onClick={() => {
                  if (mobileIndex === 0) {
                    setMobileIndex(-1);
                  } else {
                    setMobileIndex(0);
                  }
                }}
              >
                <p>{t(`appHeader.product`)}</p>
                <img src={mobileIndex === 0 ? icUp : icDown} alt="" />
              </div>
              {mobileIndex === 0 && (
                <div className="sub-wrap">
                  <div className="item">
                    <p className="strong">AI</p>
                  </div>
                  <div
                    className="item"
                    onClick={() => {
                      navigate("/product/ai/graph_rag");
                      setMenuVisible(false);
                    }}
                  >
                    <p>Graph RAG</p>
                  </div>
                  <div
                    className="item"
                    onClick={() => {
                      navigate("/product/ai/video_production");
                      setMenuVisible(false);
                    }}
                  >
                    <p>Gen-AI Video Production</p>
                  </div>
                  <div
                    className="item"
                    onClick={() => {
                      navigate("/product/ai/marketing_solution");
                      setMenuVisible(false);
                    }}
                  >
                    <p>AI Marketing Solution</p>
                  </div>
                  <div className="item" style={{ marginTop: "20px" }}>
                    <p className="strong">DBMS</p>
                  </div>
                  <div
                    className="item"
                    onClick={() => {
                      navigate("/product/dbms/agens_graph");
                      setMenuVisible(false);
                    }}
                  >
                    <p>AgensGraph</p>
                  </div>
                  <div
                    className="item"
                    onClick={() => {
                      navigate("/product/dbms/agens_sql");
                      setMenuVisible(false);
                    }}
                  >
                    <p>AgensSQL</p>
                  </div>
                  <div className="item" style={{ marginTop: "20px" }}>
                    <p className="strong">ONTOLOGY</p>
                  </div>
                  <div
                    className="item"
                    onClick={() => {
                      navigate("/product/ontology");
                      setMenuVisible(false);
                    }}
                  >
                    <p>Graph Ontology</p>
                  </div>
                </div>
              )}

              <div
                className="item"
                onClick={() => {
                  if (mobileIndex === 1) {
                    setMobileIndex(-1);
                  } else {
                    setMobileIndex(1);
                  }
                }}
              >
                <p>{t(`appHeader.service`)}</p>
                <img src={mobileIndex === 1 ? icUp : icDown} alt="" />
              </div>
              {mobileIndex === 1 && (
                <div className="sub-wrap">
                  <div
                    className="item"
                    onClick={() => {
                      navigate("/service/pgts");
                      setMenuVisible(false);
                    }}
                  >
                    <p className="strong">PGTS</p>
                  </div>
                  <div
                    className="item"
                    style={{ marginTop: "20px" }}
                    onClick={() => {
                      navigate("/service/education");
                      setMenuVisible(false);
                    }}
                  >
                    <p className="strong">Education</p>
                  </div>
                  <div
                    className="item"
                    style={{ marginTop: "20px" }}
                    onClick={() => {
                      navigate("/service/techportal");
                      setMenuVisible(false);
                    }}
                  >
                    <p className="strong">Tech Portal</p>
                  </div>
                </div>
              )}

              <div
                className="item"
                onClick={() => {
                  navigate("/resource");
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.resource`)}</p>
              </div>
              <div
                className="item"
                onClick={() => {
                  navigate("/newsroom");
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.newsRoom`)}</p>
              </div>
              <div
                className="item"
                onClick={() => {
                  navigate("/ir");
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.ir`)}</p>
              </div>
              <div
                className="item"
                onClick={() => {
                  window.open(
                    "https://jumpit.saramin.co.kr/company/MjIwODg2ODQwOA==?company_nm=%EC%8A%A4%EC%B9%B4%EC%9D%B4%EC%9B%94%EB%93%9C%EC%99%80%EC%9D%B4%EB%93%9C"
                  );
                  setMenuVisible(false);
                }}
              >
                <p>{t(`appHeader.careers`)}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppHeader;
